/**
 * Created by Shikha Gupta on 2019-09-12
 */
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { IResizeData, StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IImortalFruitsParsedServerData} from "../server/data/IImortalFruitsParsedServerData";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Container, Sprite,Graphics} from "pixi.js";
import {TweenLite,TimelineLite} from "gsap";
import {BetLineEvents} from "../betline/ImmortalFruitsBetlinesView";
import {bonusWheelEvents} from "../gameround/bonusWheelController";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {ImmortalFruitsParsedGameData} from "../server/data/ImmortalFruitsParsedGameData";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {SoundManager} from "../resource/sound/SoundManager";
import {ImmortalFruitsSoundConfig} from "../ImmortalFruitsSoundConfig";
import {ImmortalFruits} from "../ImmortalFruits";


export class Jackpot extends BaseView {
    private _layer: ScalableLayer;
    private jackpotMiniText: Sprite;
    private jackpotMidText: Sprite;
    private Invisible_mask: Sprite;
    private jackpotMaxText: Sprite;
    private gameInstance: ImmortalFruitsGameConfig;
    private jackpot_bar: PIXI.spine.Spine;
    private currentWheelLevel :number=0;


    constructor() {
        super();
        this._layer = StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.JACKPOT.name);
        this.addFeatureEventListeners();
    }

    public reset(): void {

    }

    protected initAnimations(): void {
        this.Invisible_mask = new TimelineSprite(GameResources.getTextures("Invisible_mask"));
        this.gameInstance = ImmortalFruitsGameConfig.instance;
        this.jackpot_bar = new PIXI.spine.Spine(GameResources.getSpineAsset("jackpot_bar"));
        this.jackpotMiniText = new Sprite(GameResources.getTextures("jackpot100")[0]);

        this.jackpotMidText = new Sprite(GameResources.getTextures("jackpot250")[0]);
        this.jackpotMaxText = new Sprite(GameResources.getTextures("jackpot2500")[0]);

        this.jackpotMiniText.pivot.set(this.jackpotMiniText.width / 2, this.jackpotMiniText.height / 2);
        this.jackpotMidText.pivot.set(this.jackpotMidText.width / 2, this.jackpotMidText.height / 2);
        this.jackpotMaxText.pivot.set(this.jackpotMaxText.width / 2, this.jackpotMaxText.height / 2);
        this.jackpotMiniText.position.set(Helper.getSymbolPositions(0, 0)[0] + 5, Helper.getSymbolPositions(0, 0)[1] - ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT);
        this.jackpotMidText.position.set(Helper.getSymbolPositions(2, 0)[0] + 5, Helper.getSymbolPositions(0, 0)[1] - ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT);
        this.jackpotMaxText.position.set(Helper.getSymbolPositions(4, 0)[0], Helper.getSymbolPositions(0, 0)[1] - ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT);
        this._layer.addChild(this.jackpotMiniText);
        this._layer.addChild(this.jackpotMidText);
        this._layer.addChild(this.jackpotMaxText);
        this._layer.addChild(this.Invisible_mask);
        this.jackpotMiniText.scale.set(0.85);
        this.jackpotMidText.scale.set(0.85);
        this.jackpotMaxText.scale.set(0.85);
        this.jackpot_bar.pivot.set(0.5);
        this.jackpot_bar.renderable = false;
        this._layer.addChild(this.jackpot_bar);
        this.jackpot_bar.mask = this.Invisible_mask;
        this.Invisible_mask.x = -10;
        this.Invisible_mask.y = 67;

    }

    private addFeatureEventListeners(): void {
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event: GameEvent) => this.reset());
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
        EventHandler.addEventListener(this, BetLineEvents.SHOW_JACKPOT_ANIM, (event: GameEvent) => this.fadeOutJackpots());
        EventHandler.addEventListener(this, bonusWheelEvents.SHOW_JACKPOTWON, (event: GameEvent) => this.showJackpotWonAnim());
        EventHandler.addEventListener(this, bonusWheelEvents.HIDE_JACKPOTWON, (event: GameEvent) => this.resetJackpotAnim());

    }

    private onInitDataParsed(data: IImortalFruitsParsedServerData) {

    }
    private onGameDataParsed(data: ImmortalFruitsParsedGameData) {
    if(data.LandedWheelIndex ==7){
        this.currentWheelLevel = data.wheelLevel ;
    }
    }


    protected onResize(data: IResizeData): void {
        if (data.orientation == Orientation.PORTRAIT) {
            this.Invisible_mask.x = -10;
            this.Invisible_mask.y = -19;
            StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.SYMBOLS.name).y = -ImmortalFruitsGameConfig.instance.SYMBOL_WIDTH / 2 - 20;
            StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.BET_LINES.name).y = -ImmortalFruitsGameConfig.instance.SYMBOL_WIDTH / 2 - 17;
            StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.WIN_COUNT_UP.name).y = -ImmortalFruitsGameConfig.instance.SYMBOL_WIDTH / 2 - 20;
            this.jackpotMiniText.position.set(Helper.getSymbolPositions(0, 0)[0] + 5, Helper.getSymbolPositions(0, 0)[1] - this.gameInstance.SYMBOL_HEIGHT - this.gameInstance.PORTRAIT_OFFSET + 4);
            this.jackpotMidText.position.set(Helper.getSymbolPositions(2, 0)[0] + 5, Helper.getSymbolPositions(0, 0)[1] - ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT - this.gameInstance.PORTRAIT_OFFSET + 4);
            this.jackpotMaxText.position.set(Helper.getSymbolPositions(4, 0)[0] - 5, Helper.getSymbolPositions(0, 0)[1] - ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT - this.gameInstance.PORTRAIT_OFFSET + 4);
        } else {
            this.jackpotMiniText.position.set(Helper.getSymbolPositions(0, 0)[0], Helper.getSymbolPositions(0, 0)[1] - ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT / 2 - 27);
            this.jackpotMidText.position.set(Helper.getSymbolPositions(2, 0)[0] + 5, Helper.getSymbolPositions(0, 0)[1] - ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT / 2 - 27);
            this.jackpotMaxText.position.set(Helper.getSymbolPositions(4, 0)[0] - 5, Helper.getSymbolPositions(0, 0)[1] - ImmortalFruitsGameConfig.instance.SYMBOL_HEIGHT / 2 - 27);
            StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.SYMBOLS.name).y = 0;
            StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.BET_LINES.name).y = 0;
            StageManager.getLayer(ImmortalFruitsGameConfig.instance.LAYERS.WIN_COUNT_UP.name).y = 0;
            this.Invisible_mask.x = -10;
            this.Invisible_mask.y = 67;
        }
        this.jackpot_bar.position = this.jackpotMiniText.position;
        this.jackpot_bar.x = this.gameInstance.REEL_AREA_POS_X + 336;
    }

    private fadeOutJackpots() {
        this.jackpot_bar.x = this.gameInstance.REEL_AREA_POS_X +336 ;
        let tl =new TimelineLite();
        tl.add(()=>{
            this.jackpot_bar.state.setAnimation(0, "rapid_midi_mega", false);
            SoundManager.playSound(ImmortalFruitsSoundConfig.instance.IDLE_SWEEP2,undefined,1);

        },2.5);
        tl.add(()=>{
            this.jackpot_bar.renderable = true;
            this.jackpot_bar.alpha = 1;
            if(ImmortalFruits.api.gameClientConfiguration.jurisdictionName!=="ES" && ImmortalFruits.api.gameClientConfiguration.jurisdictionName!=="LT" && ImmortalFruits.api.gameClientConfiguration.jurisdictionName!=="PT") { //#311
                this.jackpot_bar.state.setAnimation(0, "xwheel_jackpots", false);
            }else{
                this.jackpot_bar.state.setAnimation(0, "xwheel_pots", false);
            }
            SoundManager.playSound(ImmortalFruitsSoundConfig.instance.IDLE_SWEEP1,undefined,1);
        },0.18);
        tl.add(()=>{
            SoundManager.playSound(ImmortalFruitsSoundConfig.instance.IDLE_SWEEP_MULT,undefined,1);
        },5.35);
        tl.add(()=>{
            SoundManager.playSound(ImmortalFruitsSoundConfig.instance.IDLE_SWEEP_MULT,undefined,1);
            TweenLite.to(this.jackpotMiniText, 0.2, {
                alpha: 1});
        },5.6);
        tl.add(()=>{
            SoundManager.playSound(ImmortalFruitsSoundConfig.instance.IDLE_SWEEP_MULT,undefined,1);
            TweenLite.to(this.jackpotMidText, 0.2, {
                alpha: 1});
        },5.8);
        tl.add(()=>{
                TweenLite.to(this.jackpotMaxText, 0.2, {
                    alpha: 1});
            },6.1);
        tl.add(()=>{
            TweenLite.to(this.jackpotMiniText, 0.2, {
                alpha: 0});
            TweenLite.to(this.jackpotMidText, 0.2, {
                alpha: 0, onComplete: () => {

                }
            });
            TweenLite.to(this.jackpotMaxText, 0.2, {
                alpha: 0, onComplete: () => {

                }
            });
        },0);

    }
    private resetJackpotAnim(){
        this.jackpot_bar.x = this.gameInstance.REEL_AREA_POS_X  +336;
        this.jackpot_bar.renderable = false;
        TweenLite.to(this.jackpotMiniText, 0.2, {
            alpha: 1});
        TweenLite.to(this.jackpotMidText, 0.2, {
            alpha: 1});
        TweenLite.to(this.jackpotMaxText, 0.2, {
            alpha: 1});
    }
    private showJackpotWonAnim(){
        let tl =new TimelineLite();
        TweenLite.to(this.jackpotMiniText, 0.2, {
            alpha: 0});
        TweenLite.to(this.jackpotMidText, 0.2, {
            alpha: 0, onComplete: () => {

            }
        });
        TweenLite.to(this.jackpotMaxText, 0.2, {
            alpha: 0, onComplete: () => {

            }
        });
        tl.add(()=>{
            this.jackpot_bar.renderable = true;
            this.jackpot_bar.x = this.gameInstance.REEL_AREA_POS_X + 336;
            this.jackpot_bar.alpha = 1;
            if(this.currentWheelLevel==1){
                this.jackpot_bar.state.setAnimation(0, "rapid_won", false);
            }else if(this.currentWheelLevel==2){
                this.jackpot_bar.state.setAnimation(0, "midi_won", false);
            }else{
                this.jackpot_bar.state.setAnimation(0, "mega_won", false);
            }
        },0.18);
    }
}